// Configuration for the application
const config = {
    // API URL
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    
    // Version
    VERSION: '1.0.0',
    
    // Default timeout for API requests (in ms)
    API_TIMEOUT: 30000,
    
    // Feature flags
    FEATURES: {
        ADMIN_PANEL: true,
        PROFILE_PAGE: false,
        PASSWORD_RESET: false
    }
};

export default config; 